"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _component = _interopRequireDefault(require("@loadable/component"));
var _clsx = _interopRequireDefault(require("clsx"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _Input = _interopRequireDefault(require("@micado-digital/react-form/Input"));
var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));
var _Local = _interopRequireDefault(require("@micado-digital/react-ui/components/Local"));
var _CartContext = _interopRequireDefault(require("../../context/CartContext"));
var _ShopContext = _interopRequireDefault(require("../../context/ShopContext"));
var _updateRewardPoints = _interopRequireWildcard(require("../../utils/cart/updateRewardPoints"));
var _formatPrice = _interopRequireDefault(require("../../utils/formatPrice"));
var _de = _interopRequireDefault(require("../../locals/de.json"));
var _en = _interopRequireDefault(require("../../locals/en.json"));
var _it = _interopRequireDefault(require("../../locals/it.json"));
var _RewardPoints = _interopRequireDefault(require("./RewardPoints.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Alert = (0, _component.default)(() => import("@material-ui/lab/Alert"));
const LoadingIcon = (0, _component.default)(() => import("../LoadingIcon"));
const RewardPoints = _ref => {
  let {
    customerPoints,
    lang,
    max,
    min,
    onShowMessage
  } = _ref;
  const {
    shopData
  } = (0, _react.useContext)(_ShopContext.default);
  const {
    currency: {
      isoCode
    } = {},
    locale = "de-DE",
    rewardPoints: shopRewardPoints
  } = shopData || {};
  const {
    maxRedeemable = 0,
    minOrderValue = 0,
    minRedeemable = 0
  } = shopRewardPoints || {};
  const {
    cart: {
      rewardPoints: {
        earnAmount = 0,
        redeemAmount = 0
      } = {}
    } = {},
    setCart
  } = (0, _react.useContext)(_CartContext.default);
  const [isEditing, setIsEditing] = (0, _react.useState)(false);
  const [loading, setLoading] = (0, _react.useState)(false);
  const [messageObj, setMessageObj] = (0, _react.useState)({});
  const [value, setValue] = (0, _react.useState)("");
  const css = (0, _RewardPoints.default)();
  const l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      it: _it.default
    }
  });
  const hasValue = (0, _react.useMemo)(() => {
    return value !== "";
  }, [value]);
  const handleDelete = async e => {
    e.preventDefault();
    const response = await (0, _updateRewardPoints.default)(0);
    const {
      msg
    } = response || {};
    if (msg) {
      showMessage(l("reactShop.messages.errors.".concat(_updateRewardPoints.UPDATE_REWARD_POINTS_ERRORS[msg]), {
        value
      }), "error");
      return;
    }
    localStorage.setItem("mco-shop-cart", JSON.stringify(response));
    setCart(response);
    showMessage(l("reactShop.messages.success.REWARDPOINTS_DELETED"), "success");
  };
  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    const response = await (0, _updateRewardPoints.default)(value !== "" ? value : customerPoints);
    const {
      msg
    } = response || {};
    setLoading(false);
    if (msg) {
      showMessage(l("reactShop.messages.errors.".concat(_updateRewardPoints.UPDATE_REWARD_POINTS_ERRORS[msg]), {
        value
      }), "error");
      return;
    }
    localStorage.setItem("mco-shop-cart", JSON.stringify(response));
    setCart(response);
    setIsEditing(false);
    setValue("");
  };
  const showMessage = (message, type) => {
    if (onShowMessage) {
      onShowMessage({
        message,
        type
      });
      setTimeout(() => {
        onShowMessage({});
      }, 2000);
      return;
    }
    setMessageObj({
      message,
      type
    });
    setTimeout(() => {
      setMessageObj(null);
    }, 2000);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.rewardPoints, "mco-shop-reward-points")
  }, redeemAmount > 0 && /*#__PURE__*/_react.default.createElement(Alert, {
    classes: {
      root: css.redeemAmount
    },
    action: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: css.buttonEdit,
      fullWidth: true,
      size: "small",
      variant: "outlined",
      onClick: () => setIsEditing(true)
    }, /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.rewardPoints.buttons.edit",
      l: l
    })), /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: css.buttonDelete,
      fullWidth: true,
      size: "small",
      variant: "outlined",
      onClick: handleDelete
    }, /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.rewardPoints.buttons.delete",
      l: l
    }))),
    severity: "success"
  }, /*#__PURE__*/_react.default.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: l("reactShop.cart.text.redeemRewardPoints", {
        redeemAmount
      })
    }
  })), (redeemAmount === 0 || isEditing) && /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: handleSubmit
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: css.wrapper
  }, /*#__PURE__*/_react.default.createElement(_Input.default, {
    label: l("reactShop.rewardPoints.label"),
    name: "rewardPoints",
    TextfieldProps: {
      inputProps: {
        max,
        min
      },
      type: "number",
      value: value,
      variant: "outlined",
      onChange: e => {
        setValue(e.target.value);
      }
    }
  }), /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: (0, _clsx.default)(css.button, "mco-shop-reward-points__button", {
      [css.isLoading]: loading
    }),
    color: "primary",
    disabled: loading,
    fullWidth: true,
    type: "submit",
    variant: "outlined"
  }, loading ? /*#__PURE__*/_react.default.createElement(LoadingIcon, null) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, hasValue ? /*#__PURE__*/_react.default.createElement(_Local.default, {
    identifier: "reactShop.rewardPoints.buttons.redeem",
    l: l
  }) : /*#__PURE__*/_react.default.createElement(_Local.default, {
    identifier: "reactShop.rewardPoints.buttons.redeemAll",
    l: l
  }))))), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: css.text,
    dangerouslySetInnerHTML: {
      __html: l("reactShop.cart.text.rewardPoints", {
        maxRedeemable,
        minRedeemable,
        minOrderValue: (0, _formatPrice.default)(minOrderValue, isoCode, locale)
      })
    },
    variant: "body2"
  }), earnAmount > 0 && /*#__PURE__*/_react.default.createElement(Alert, {
    className: css.information,
    children: /*#__PURE__*/_react.default.createElement("p", {
      dangerouslySetInnerHTML: {
        __html: l("reactShop.cart.text.earnRewardPoints", {
          earnAmount
        })
      }
    }),
    severity: "info"
  }), !(0, _isEmpty.default)(messageObj) && /*#__PURE__*/_react.default.createElement(Alert, {
    className: css.message,
    severity: messageObj === null || messageObj === void 0 ? void 0 : messageObj.type
  }, messageObj === null || messageObj === void 0 ? void 0 : messageObj.message));
};
var _default = exports.default = RewardPoints;